import { HTTP_STATUS_OK } from "../smartpak/httpstatus";

const HIDE_CLASS = 'jsHide',
    customerView = {
        setCartItemCount: function (count) {
            if (isNaN(count)) {
                return;
            }

            const $itemCount = document.getElementById('itemCount');

            if ($itemCount) {
                const $badge = $itemCount.querySelector('.cart-badge');

                if (count === 0) {
                    $itemCount.classList.add(HIDE_CLASS);
                    return;
                }

                if ($badge) {
                    $badge.innerHTML = count;
                    $itemCount.classList.remove(HIDE_CLASS);
                }
            }
        },

        setLoginStatus: function (isLoggedIn) {
            const $login = document.getElementById('nav-account-first-focus');

            if ($login) {
                if (!isLoggedIn) {
                    $login.href = `/account/login?returnUrl=${encodeURIComponent(location.pathname+location.search)}&create=true`;
                    $login.innerText = 'Sign in';
                } else {
                    $login.href = '/account/signout';
                    $login.innerText = 'Sign Out';
                }
                $login.classList.remove(HIDE_CLASS);
            }
        },

        setFirstName: function (name) {
            Array.from(document.querySelectorAll('.custFirstName')).forEach($element => ($element.innerHTML = name));
        },

        setGreeting: function (name, isTaxExempt) {
            const $greeting = document.getElementById('account-greeting');
            const $secondaryMessaging = document.getElementById('account-type');

            if ($greeting && name) {
                $greeting.innerHTML = `Hi, ${name}`;
                $greeting.classList.remove(HIDE_CLASS);
            }

            if($secondaryMessaging && isTaxExempt) {
                $secondaryMessaging.innerHTML = `<span class="nobr">Tax Exempt <span class="icon"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M256,0C114.615,0,0,114.615,0,256s114.615,256,256,256,256-114.615,256-256S397.384,0,256,0ZM72.294,111.748l70.582,70.582c-3.181,30.154,10.739,56.982,36.552,73.529,18.053,11.569,41.464,18.793,61.53,24.554l60.326,60.326c-1.142.633-2.332,1.211-3.576,1.708-12.592,5.094-31.834,7.216-55.886,3.679-11.46-1.839-31.693-8.206-48.812-13.724-10.328-3.254-20.657-6.508-30.985-9.762-3.113-.99-6.225-1.981-9.338-2.971l-18.252,58.292c3.254.99,6.367,1.981,9.621,2.971,9.338,2.83,18.534,5.801,27.872,8.772,14.007,4.528,35.23,11.319,51.783,14.997v55.038h61.263v-52.066c12.592-1.415,24.618-4.245,35.654-8.772,8.847-3.596,17.199-8.321,24.621-14.195l55.001,55.001c-39.714,31.187-89.821,49.83-144.252,49.83-128.931,0-233.535-104.604-233.535-233.535,0-54.431,18.643-104.538,49.83-144.252ZM439.705,400.252l-64.724-64.724c6.027-32.776-6.849-63.282-34.261-82.075-21.081-14.431-49.237-22.496-71.308-28.721l-1.132-.283c-2.097-.597-4.129-1.179-6.131-1.753l-47.933-47.933c2.19-1.579,4.629-2.966,7.232-4.078,13.017-5.659,32.4-8.348,55.603-4.952,23.487,3.537,46.407,9.197,69.469,14.997l14.856-59.282c-25.326-6.367-50.652-12.592-76.543-16.271h-.141v-52.915h-61.121v54.189c-9.196,1.839-18.11,4.527-26.316,8.065-9.594,4.127-18.799,9.597-26.837,16.45l-58.671-58.671c39.714-31.187,89.821-49.83,144.252-49.83,128.931,0,233.535,104.604,233.535,233.535,0,54.431-18.643,104.538-49.83,144.252Z" style="stroke-width:0px;"></path></svg></span></span>`;
                $secondaryMessaging.classList.remove(HIDE_CLASS);
            }
        },

        setAccountLink: function (customer) {
            const $account = document.getElementById('mobile-account-link');

            if ($account) {
                var taxExempt = customer.isTaxExempt
                                ? `<span class="account-type small nobr">&nbsp;&nbsp;&bull;&nbsp;&nbsp;Tax Exempt <span class="icon" data-size="sm"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M256,0C114.615,0,0,114.615,0,256s114.615,256,256,256,256-114.615,256-256S397.384,0,256,0ZM72.294,111.748l70.582,70.582c-3.181,30.154,10.739,56.982,36.552,73.529,18.053,11.569,41.464,18.793,61.53,24.554l60.326,60.326c-1.142.633-2.332,1.211-3.576,1.708-12.592,5.094-31.834,7.216-55.886,3.679-11.46-1.839-31.693-8.206-48.812-13.724-10.328-3.254-20.657-6.508-30.985-9.762-3.113-.99-6.225-1.981-9.338-2.971l-18.252,58.292c3.254.99,6.367,1.981,9.621,2.971,9.338,2.83,18.534,5.801,27.872,8.772,14.007,4.528,35.23,11.319,51.783,14.997v55.038h61.263v-52.066c12.592-1.415,24.618-4.245,35.654-8.772,8.847-3.596,17.199-8.321,24.621-14.195l55.001,55.001c-39.714,31.187-89.821,49.83-144.252,49.83-128.931,0-233.535-104.604-233.535-233.535,0-54.431,18.643-104.538,49.83-144.252ZM439.705,400.252l-64.724-64.724c6.027-32.776-6.849-63.282-34.261-82.075-21.081-14.431-49.237-22.496-71.308-28.721l-1.132-.283c-2.097-.597-4.129-1.179-6.131-1.753l-47.933-47.933c2.19-1.579,4.629-2.966,7.232-4.078,13.017-5.659,32.4-8.348,55.603-4.952,23.487,3.537,46.407,9.197,69.469,14.997l14.856-59.282c-25.326-6.367-50.652-12.592-76.543-16.271h-.141v-52.915h-61.121v54.189c-9.196,1.839-18.11,4.527-26.316,8.065-9.594,4.127-18.799,9.597-26.837,16.45l-58.671-58.671c39.714-31.187,89.821-49.83,144.252-49.83,128.931,0,233.535,104.604,233.535,233.535,0,54.431-18.643,104.538-49.83,144.252Z" style="stroke-width:0px;"></path></svg></span></span>`
                                : ``;
                    var loggedOut = `Sign in&nbsp;&bull;&nbsp;Account`,
                    loggedIn = `<span class="account-greeting">Hi, ${customer.firstName}</span>
                                <div class="account-messaging nobr">
                                    Account` + taxExempt + `<span class="icon"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512"><!-- Font Awesome Pro 5.15.4 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) --><path d="M224.3 273l-136 136c-9.4 9.4-24.6 9.4-33.9 0l-22.6-22.6c-9.4-9.4-9.4-24.6 0-33.9l96.4-96.4-96.4-96.4c-9.4-9.4-9.4-24.6 0-33.9L54.3 103c9.4-9.4 24.6-9.4 33.9 0l136 136c9.5 9.4 9.5 24.6.1 34z"></path></svg></span>
                                </div>`;

                $account.innerHTML = customer.isLoggedIn || customer.isCookiedIn ? loggedIn : loggedOut;
            }
        },

        setSmartPaksNavList: function ($navigation) {
            const $managerLink = $navigation.querySelector('[href="#smartpak-manager-link"]');
            const $button = $navigation.querySelector('#build-smartpaks-button .text');
            const $mySmartPaks = document.querySelectorAll('.smartpak-management-url');

            if ($managerLink) {
                fetch('/api/recipient/GetFirstDisplayableRecipientId/1')
                    .then(r => r.json())
                    .then(r => {
                        if (r.Status === HTTP_STATUS_OK) {
                            $managerLink.href = `/autoshipmanager/supplements/${r.Content}`;
                            [...$mySmartPaks].forEach($link => $link.href = `/autoshipmanager/supplements/${r.Content}`);
                        }
                    });
            }

            if ($button) {
                $button.innerHTML = 'Manage SmartPaks';
            }
        },

        checkBackOrderItem: function (hasActionableClaims) {
            const $backOrderItem = document.getElementById('back-order-item-msg');

            if ($backOrderItem) {
                $backOrderItem.classList[hasActionableClaims ? 'remove' : 'add'](HIDE_CLASS);
            }
        },

        addMobileColicareMessage: function (horseName) {
            const $ribbon = document.getElementById('site-ribbon'),
                message = `<div>${horseName} is eligible to apply for ColiCare. <span class="colicareFinePrint">Don't miss out on $15,000! <a href="/colicare/registration">Apply now</a></span></div>`;

            if (!$ribbon) {
                return;
            }

            let $list = $ribbon.querySelector('ul'),
                $listItem = document.createElement('li');

            if ($list) {
                $listItem.id = 'colicare-ribbon-message';
                $listItem.innerHTML = message;
                $list.appendChild($listItem);
            }
        },

        showCreditCardMessage: function () {
            const $acctUpdate = document.getElementById('custAcctUpdate');

            if ($acctUpdate) {
                $acctUpdate.style.display = 'inline';
            }
        },

        showContactUsMessage: function () {
            const $contactUs = document.getElementById('custContactUs');

            if ($contactUs) {
                $contactUs.style.display = 'inline';
            }
        }
    };

export default customerView;
